import React, {FunctionComponent} from "react";
import {observer} from "mobx-react";
import {Main} from './components/Main';



interface IConfirmTranslateProps {
}


export const ConfirmTranslate: FunctionComponent<IConfirmTranslateProps> = function (props) {
    return <Main/>
}



